import {
  GET_ALL_ENROLLMENTS,
  RESET_GET_ALL_ENROLLMENTS,
  ResetGetAllEnrollments,
  GetAllEnrollments,
} from "../types/enrollment/get-all.dto";

import {
  GET_ONE_ENROLLMENT,
  RESET_GET_ONE_ENROLLMENT,
  GetOneEnrollment,
  ResetGetOneEnrollment,
} from "../types/enrollment/get-one.dto";

import {
  UPDATE_ENROLLMENT,
  RESET_UPDATE_ENROLLMENT,
  UpdateEnrollment,
  ResetUpdateEnrollment,
} from "../types/enrollment/update.dto";

import {
  NEW_ENROLLMENT,
  CreateOneEnrollment,
  RESET_NEW_ENROLLMENT,
} from "../types/enrollment/new.dto";

import { GetAllCoursesOutDto } from "../../types/course.dto";
import { NewEnrollmentOutDto } from "../../types/enrollment.dto";

export const getAllEnrollments = (
  payload: GetAllCoursesOutDto
): GetAllEnrollments => {
  return { type: GET_ALL_ENROLLMENTS, payload };
};

export const resetGetAllEnrollments = (): ResetGetAllEnrollments => {
  return { type: RESET_GET_ALL_ENROLLMENTS, payload: null };
};

export const getOneEnrollment = (payload): GetOneEnrollment => {
  return { type: GET_ONE_ENROLLMENT, payload };
};

export const resetGetOneEnrollment = (): ResetGetOneEnrollment => {
  return { type: RESET_GET_ONE_ENROLLMENT, payload: null };
};

export const updateOneEnrollment = (payload): UpdateEnrollment => {
  return { type: UPDATE_ENROLLMENT, payload };
};

export const resetUpdateOneEnrollment = (): ResetUpdateEnrollment => {
  return { type: RESET_UPDATE_ENROLLMENT, payload: null };
};

export const createNewEnrollment = (
  payload: NewEnrollmentOutDto
): CreateOneEnrollment => {
  return { type: NEW_ENROLLMENT, payload };
};

export const resetCreateNewEnrollment = () => {
  return { type: RESET_NEW_ENROLLMENT, payload: null };
};
